import React, { useState, useEffect } from "react";
// import "./";
import { Link, useNavigate } from "react-router-dom";
import { getProductList } from "../../Apis/Setting";
import { placeOrderApi } from "../../Apis/Order";
import Swal from "sweetalert2";
import { loadScript } from "../Dashboard/Default/utils";
import Loader from "../../Modules/Settings/Loader";


const BuyDevice = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const [comboItems, setComboItems] = useState([]);
    const [selectedAddons, setSelectedAddons] = useState([]);
    const [OrderResponse, setOrderResponse] = useState({});
    const [isformfields, setisformfields] = useState(true);

    let navigate = useNavigate();

    const handleCheckboxChange = (addon) => {
        setSelectedAddons((prevSelected) => {
            const exists = prevSelected.some((item) => item.product_id?._id === addon.product_id?._id);
            return exists
                ? prevSelected.filter((item) => item.product_id?._id !== addon.product_id?._id) // Uncheck
                : [...prevSelected, addon]; // Check
        });
    };
    useEffect(() => {
        // Set default checked state when comboItems are available
        if (comboItems?.length > 0) {
            setSelectedAddons(comboItems.map(addon => ({
                product_id: addon.product_id // Ensure correct structure
            })));
        }
    }, [comboItems]);

    useEffect(() => {
        const fetchProductList = async () => {
            setLoadings(true);
            try {
                const productsData = await getProductList();
                console.log("productsData...", productsData);
                setProducts(productsData?.data);
                setComboItems(productsData?.data[0]?.comboItems);
                setisformfields(productsData?.is_form_flag);
            } catch (error) {
                console.error("Error fetching products:", error);

            } finally {
                setLoadings(false);
            }
        };
        fetchProductList();
    }, []);



    const subtotal =
    selectedAddons.reduce((sum, addon) => sum + (addon.product_id?.price || 0), 0) + 
    (products[0]?.price || 0);
    
  
    const discount = (subtotal * (products[0]?.discount / 100 || 0)).toFixed(2);
// Calculate discount
    const gst = (subtotal - discount) * products[0]?.gst/100; // Calculate 18% GST after discount
    
 // 10% Discount on subtotal
  
  const totalPrice = subtotal + gst - discount; // Apply discount after adding GST
  


    const handlePayment = async (product) => {
        try {
            setLoading(true);
            const orderData = {
                items: [
                    {
                        product_id: product._id,
                        quantity: "1",
                        ...(selectedAddons.length > 0 && { comboItems: selectedAddons }), // Conditionally add comboItems if they exist
                    },
                ],
                total_price: totalPrice.toString(), // Ensure this includes add-ons in calculation
            };



            const orderResponse = await placeOrderApi(orderData);
            console.log("orderResponse", orderResponse);
            if (orderResponse?.statusCode !== 200) {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Order Failed",
                    text: orderResponse?.message || "Unable to place order. Try again.",
                });
                return;
            }

            const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
            if (!res) {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Payment Failed",
                    text: "Razorpay SDK failed to load. Check your internet connection.",
                });
                return; 
            }
            const options = {
                key: "rzp_live_Ng9k5DWH8OqTmi",
                amount:Math.round( parseFloat(subtotal) * 100),
                currency: "INR",
                name: product?.title,
                order_id: orderResponse?.data?.id,
                // description: product.description,
                image: product?.product_image,
                // handler: (response) => {
                //     {
                //         navigate("/order-list", { state: { orderData: orderResponse } }); // Navigate after success message
                //     };
                // },
                handler: (response) => {
                    console.log("Payment Success:", response);
                    
                    // Show Payment ID Alert
                    Swal.fire({
                        icon: "success",
                        title: "Payment Successful",
                        html: `Your payment was successful!<br><b>Payment ID:</b> ${response.razorpay_payment_id}`,
                    }).then(() => {
                        // Navigate after success message
                        navigate("/order-list", { state: { orderData: orderResponse } });
                    });
                },
                prefill: {
                    name: "Your Name",
                    email: "your-email@example.com",
                    contact: "9999999999",
                },
                theme: { color: "#e74c3c" },
            };


            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error("Error processing payment:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong during payment.",
            });
        } finally {
            setLoading(false);

        }

    };
    console.log("comboItems", comboItems);
    console.log("selectedAddons", selectedAddons);
    console.log("products", products);
    return (
        <>
            <div className="product-container">
                <div className="container">
                    {loadings && <Loader />}

                    {products.map((product) => (
                        <div className="px-5 py-3" key={product._id}>
                            {console.log("product Item", product)}
                            <h2 className="text-3xl font-bold mb-1">{product.title}</h2>
                            <p className="text-gray-600 text-sm">{product.description}</p>
                             {isformfields ===false && (
                                     <div
                                        className="custom-card d-flex align-items-center mt-4 complete-card"
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-user-round h-12 w-12 text-primary"><path d="M18 20a6 6 0 0 0-12 0"></path><circle cx="12" cy="10" r="4"></circle><circle cx="12" cy="12" r="10"></circle></svg>
                                        <div class="ps-3">
                                          <h3 class="text-lg font-semibold mb-0">Complete Your Profile</h3>
                                          <p class="text-muted-foreground m-0">Update your profile with bank details and address to start ordering devices.</p>     </div>
                                        <div className="ms-auto">
                                          <Link to="/profile" className="btn btn--form update-profile-btn">
                                            Update Profile
                                          </Link>
                                        </div>
                                      </div>
                                      )}
                            <div className="custom-card buy-device-card d-flex flex-wrap mt-4 p-0 max-w-5xl mx-auto product-box-card">
                                <div className="w-100 cc-header p-4 d-flex align-items-center justify-content-between">
                                    <div className="font-semibold tracking-tight text-3xl">{product.title}</div>
                                    <div className="in-stock-tag">In Stock</div>
                                </div>
                                <div className="w-50 p-4">
                                    <div className="bg-muted rounded-xl h-460 w-100 d-flex align-items-center justify-content-center  p-4 position-relative">
                                        <img
                                            src={product.product_image}
                                            alt={product.title}
                                            className="product-image"
                                        />
                                    </div>
                                    <div>
                                        <div className="mt-3">
                                            <p className="text-sm text-muted-foreground">Model Number</p>
                                            <p className="font-medium block m-0 text-sm">{products[0]?.model_number}</p>
                                        </div>
                                        <div className="mt-3">
                                            <p className="text-sm text-muted-foreground mb-2">Key Features</p>
                                            <div className="row">
                                                <div className="col-6 mb-3">
                                                    <p className="block m-0 text-sm key-feature">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zap h-4 w-4 text-primary"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>
                                                        Quick Setup
                                                    </p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="block m-0 text-sm key-feature">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield h-4 w-4 text-primary"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
                                                        Secure Tracking
                                                    </p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="block m-0 text-sm key-feature">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock h-4 w-4 text-primary"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                                        24/7 Support
                                                    </p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="block m-0 text-sm key-feature">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check h-4 w-4 text-primary"><path d="M20 6 9 17l-5-5"></path></svg>
                                                        1 Year Warranty
                                                    </p>
                                                </div>
                                                {/* <div className="col-6 mb-3">
                                                    <p className="block m-0 text-sm key-feature">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck h-4 w-4 text-primary"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>
                                                        Free Shipping
                                                    </p>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-50 p-4 border-l"> 
                                    <p className="text-sm text-muted-foreground">Base Price</p>
                                    <p className="text-4xl font-bold">₹{products[0]?.sub_total}</p>
                                    <hr />
                                    <h3 className="font-semibold text-lg">Combo Packs</h3>
                                    <div className="addon-list">
                                        {comboItems?.map((addon, index) => (
                                            <div key={addon._id} className="addon-card">
                                                <div className='custom-checkbox'>
                                                <input
                    type="checkbox"
                    id={`addOns${index}`}
                    className='styled-checkbox'
                    checked={selectedAddons.some((item) => item.product_id?._id === addon.product_id?._id)}
                    onChange={() => handleCheckboxChange(addon)}
                />
                                                    <label htmlFor={`addOns${index}`}></label>
                                                </div>
                                                {/* <input
                                                    type="checkbox"
                                                    className="addon-checkbox"
                                                    checked={selectedAddons.some((item) => item.product_id?._id === addon.product_id?._id)}
                                                    onChange={() => handleCheckboxChange(addon)}
                                                /> */}

                                                <img src={addon?.product_id?.product_image} alt={addon?.product_id?.title} className="addon-image" />
                                                <div className="addon-info ps-2">
                                                    <h3 className="font-medium block m-0 text-sm" >{addon.product_id?.title}</h3>
                                                    <p className="text-sm text-muted-foreground my-1">{addon?.product_id?.description}</p>
                                                    {/* <h4 className="text-sm font-medium m-0">₹{addon?.product_id?.price}</h4> */}
                                                    {addon?.product_id?.price > 0 && (
                                                    <h4 className="text-sm font-medium m-0">₹{addon?.product_id?.price}</h4>
                                                    )}

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-4 col-4">
                                            <p className="text-xs mb-1 text-muted-foreground">Subtotal</p>
                                            <p className="text-md font-bold mt-0">₹{subtotal.toFixed(2)}</p>
                                        </div>
                                        {/* <div className="col-md-4 col-4">
                                            <p className="text-xs mb-1 text-muted-foreground">GST ({products[0]?.gst}%)</p>
                                            <p className="text-md font-bold mt-0">₹{gst.toFixed(2)}</p>
                                        </div>
                                        <div className="col-md-4 col-4">
                                            <p className="text-xs mb-1 text-muted-foreground"style={{ color: "red" }}>Discount({products[0]?.discount}%)</p>
                                            <p className="text-md font-bold mt-0 text-red-500" style={{ color: "red" }}>₹{discount}</p>

                                        </div> */}
                                        {products[0]?.gst !== 0 && (
                                        <div className="col-md-4 col-4">
                                            <p className="text-xs mb-1 text-muted-foreground">
                                            GST ({products[0]?.gst}%)
                                            </p>
                                            <p className="text-md font-bold mt-0">
                                            ₹{gst.toFixed(2)}
                                            </p>
                                        </div>
                                        )}

                                        {products[0]?.discount !== 0 && (
                                        <div className="col-md-4 col-4">
                                            <p className="text-xs mb-1 text-muted-foreground" style={{ color: "red" }}>
                                            Discount ({products[0]?.discount}%)
                                            </p>
                                            <p className="text-md font-bold mt-0 text-red-500" style={{ color: "red" }}>
                                            ₹{discount}
                                            </p>
                                        </div>
                                        )}

                                    </div>
                                    <hr className="my-3" />
                                    <p className="text-sm text-muted-foreground">Total Price</p>
                                    <p className="text-4xl font-bold">₹{totalPrice.toFixed(2)}</p>
                                    <div className="mt-3 text-center">
                                        <button
                                            className="btn btn--form buy-now-btn w-100"
                                            onClick={() => handlePayment(product)}
                                            disabled={loading} // Disable button when loading
                                        >
                                            {loading ? (
                                                <div className="loader mr-2"></div> // Simple loader
                                            ) : null}
                                            {loading ? "Processing..." : (
                                                <>Buy Now</>
                                            )}
                                        </button>
                                    </div>
                                    {/* <div>
                                        <h2 className="text-2xl font-bold mt-0 mb-3">{product.title}</h2>
                                        <p className="text-muted-foreground mb-3">{product.description}</p>
                                        <button
                                              className="btn btn--form buy-now-btn"
                                              onClick={() => handlePayment(product)}
                                              disabled={loading} // Disable button when loading
                                            >
                                              {loading ? (
                                                <div className="loader mr-2"></div> // Simple loader
                                              ) : null}
                                              {loading ? "Processing..." : (
                                                <>Buy Now <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right h-4 w-4"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
                                                </>
                                              )}
                                            </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6">
                        {products.map((product) => (
                            <div
                                key={product._id}
                                className="bg-white shadow-lg rounded-2xl p-4 hover:shadow-xl transition-shadow duration-300"
                            >
                                <img
                                    src={product.product_image}
                                    alt={product.title}
                                    className="product-image"
                                />
                                <h2 className="text-lg font-semibold mt-4 text-gray-800">
                                    {product.title}
                                </h2>
                                <p className="text-gray-600 text-sm mt-2">{product.description}</p>
                                {product?.product_status === "Placed" && (
                                    <p style={{
                                        color: "green",
                                        border: "1px solid lightgreen",
                                        borderRadius: "4px",
                                        padding: "2px 6px",
                                        display: "inline-block"
                                    }} className="text-green-600 text-xs mt-2">Order is Already Placed</p>
                                )}
                                <div className="flex items-center justify-between mt-2">
                                    <h3 className="text-xl font-bold text-blue-600">₹{product.price}</h3>
                                    <button
                                        className="mt-5 w-full bg-red-500 text-white py-2 rounded-lg shadow-md hover:bg-red-600 buy-button flex items-center justify-center"
                                        onClick={() => handlePayment(product)}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div className="loader mr-2"></div>
                                        ) : null}
                                        {loading ? "Processing..." : "Buy Now"}
                                    </button>


                                </div>


                            </div>
                        ))}
                    </div>
                    <h2 className="addon-heading">Combo Packs</h2>
                    <div className="addon-list">
                        {comboItems?.map((addon) => (
                            <div key={addon._id} className="addon-card">
                                <input
                                    type="checkbox"
                                    className="addon-checkbox"
                                    checked={selectedAddons.some((item) => item.product_id?._id === addon.product_id?._id)}
                                    onChange={() => handleCheckboxChange(addon)}
                                />

                                <img src={addon?.product_id?.product_image} alt={addon?.product_id?.title} className="addon-image" />
                                <div className="addon-info">
                                    <h3 className="addon-name">{addon.product_id?.title}</h3>
                                    <p className="addon-description">{addon?.product_id?.description}</p>
                                    <h4 className="addon-price">₹{addon?.product_id?.price}</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="invoice-details">
                        <h2>Invoice Summary</h2>
                        <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
                        <p>GST (18%): ₹{gst.toFixed(2)}</p>
                        <p>Shipping: ₹{shipping.toFixed(2)}</p>
                        <hr />
                        <h3>Total Price: ₹{totalPrice.toFixed(2)}</h3>
                        *Price Inclusive of GST and Shipping
                    </div> */}

                </div>
            </div>
        </>
    )
}

export default BuyDevice